(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[821],{

/***/ 49600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77848)


/***/ }),

/***/ 39822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "wd", ({
  enumerable: true,
  get: function get() {
    return _useSearchNew["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _useSearchNew = _interopRequireDefault(__webpack_require__(97312));
var _fetcher = _interopRequireDefault(__webpack_require__(68419));

/***/ }),

/***/ 97312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _fetcher = _interopRequireDefault(__webpack_require__(68419));
var _LanguageProvider = __webpack_require__(8989);
var _cache = __webpack_require__(75800);
var _react = __webpack_require__(34885);
var _addSortFilters = _interopRequireDefault(__webpack_require__(58478));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _filters = __webpack_require__(60461);
var _removeAdditionalParameterFromFiltersPickedFromUrl = __webpack_require__(35026);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  searchPath: "/catalogsearch/result/"
};
var useSearchNew = function useSearchNew(_ref) {
  var initialData = _ref.initialData,
    cacheSSR = _ref.cacheSSR,
    router = _ref.router,
    _ref$searchPath = _ref.searchPath,
    searchPath = _ref$searchPath === void 0 ? defaultProps.searchPath : _ref$searchPath;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var translations = {
    recommended: (0, _langLibrary["default"])("recommended"),
    priceCatalogHigh: (0, _langLibrary["default"])("price catalog low to high"),
    priceCatalogLow: (0, _langLibrary["default"])("price catalog high to low"),
    finalPriceHigh: (0, _langLibrary["default"])("price low to high"),
    finalPriceLow: (0, _langLibrary["default"])("price high to low"),
    sortByNameDesc: (0, _langLibrary["default"])("sortByNameDesc"),
    sortByNameAsc: (0, _langLibrary["default"])("sortByNameAsc")
  };
  var _useState = (0, _react.useState)({
      pickedFiltersKeys: initialData.filters.filter(function (filter) {
        return filter.value;
      }).map(function (filter) {
        return filter.id;
      }),
      initialFilters: initialData.defaultFilters
    }),
    filtersState = _useState[0],
    setFiltersState = _useState[1];
  var fetchedDataCache = (0, _cache.getResultFromCache)((0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(decodeURIComponent(router.asPath)), cacheSSR);
  var data = fetchedDataCache;
  var changeSearchPagination = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(filtersValue) {
      var page,
        empty,
        query,
        filterString,
        url,
        responseFromCache,
        _filtersReduce,
        pickedFilters,
        response,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              empty = _args.length > 2 ? _args[2] : undefined;
              query = _args.length > 3 ? _args[3] : undefined;
              filterString = "";
              filtersValue.forEach(function (filter) {
                if (filter.committedValue) {
                  if (filter.id === "sort" && filter.value) {
                    var _filter$value$value$s = filter.value.value.split("-"),
                      _filter$value$value$s2 = (0, _slicedToArray2["default"])(_filter$value$value$s, 2),
                      name = _filter$value$value$s2[0],
                      direction = _filter$value$value$s2[1];
                    filterString += "dir=".concat(direction, "&order=").concat(name, "&");
                  } else if (filter.type === "range") {
                    var _filter$value;
                    filterString += ((_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.from) !== undefined ? "".concat(filter.id, "=").concat(filter.value.from, "-").concat(filter.value.to, "&") : "";
                  } else {
                    if (!filter.value) return;
                    filterString += "".concat(filter.id, "=").concat(filter.value.map(function (val) {
                      return val.id;
                    }).join(","), "&");
                  }
                }
              });
              filterString = filterString.substring(0, filterString.length - 1);
              if (filterString) {
                filterString = "".concat(filterString);
              }
              filterString = filterString ? "?".concat(filterString) : "";
              url = "".concat(searchPath + query).concat(filterString).concat(filterString ? "&p=1" : "?p=1");
              url = url.replace(/p=[0-9]*/, "p=".concat(page));
              responseFromCache = (0, _cache.getResultFromCache)(url.replace(/p=[0-9]*/, "p=".concat(page)), cacheSSR);
              _filtersReduce = (0, _filters.filtersReduce)(filtersValue, filtersState.pickedFiltersKeys), pickedFilters = _filtersReduce.pickedFilters;
              if (!(responseFromCache !== null && responseFromCache !== void 0)) {
                _context.next = 16;
                break;
              }
              _context.t0 = responseFromCache;
              _context.next = 19;
              break;
            case 16:
              _context.next = 18;
              return (0, _fetcher["default"])({
                phrase: query,
                language: language,
                pickedFilters: pickedFilters,
                currentPage: page,
                pageSize: __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange,
                initialFilters: filtersState.initialFilters
              });
            case 18:
              _context.t0 = _context.sent;
            case 19:
              response = _context.t0;
              if (!responseFromCache) {
                (0, _cache.setUrlInCache)(url, response, cacheSSR);
              }
              return _context.abrupt("return", url);
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function changeSearchPagination(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  (0, _addSortFilters["default"])(data.filters, translations, false, true);
  return _objectSpread(_objectSpread({}, data), {}, {
    changeSearchPagination: changeSearchPagination
  });
};
var _default = useSearchNew;
exports["default"] = _default;

/***/ }),

/***/ 58478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var addSortFilters = function addSortFilters(filters, translations) {
  var _global$__appConfig__;
  var addWithoutValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var forSearchPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var sortFound = filters === null || filters === void 0 ? void 0 : filters.find(function (filter) {
    return filter.id === "sort";
  });
  var options = [{
    id: "position-desc",
    value: "position-desc",
    label: translations.recommended
  }, {
    id: "final_price-desc",
    value: "final_price-desc",
    label: translations.finalPriceLow
  }, {
    id: "final_price-asc",
    value: "final_price-asc",
    label: translations.finalPriceHigh
  }, {
    id: "name-desc",
    value: "name-desc",
    label: translations.sortByNameDesc
  }, {
    id: "name-asc",
    value: "name-asc",
    label: translations.sortByNameAsc
  }];
  if ((_global$__appConfig__ = __webpack_require__.g.__appConfig__.showSortByCatalogPrice) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : true) {
    options.push({
      id: "price-desc",
      value: "price-desc",
      label: translations.priceCatalogLow
    });
    options.push({
      id: "price-asc",
      value: "price-asc",
      label: translations.priceCatalogHigh
    });
  }
  var sort = {
    id: "sort",
    label: "Sort",
    type: "select",
    options: options,
    value: sortFound ? sortFound.value : null
  };
  if (forSearchPage) {
    sort.options.splice(0, 1);
  }
  if (sortFound && !addWithoutValue) {
    filters[filters.length - 1] = sort;
  } else {
    filters === null || filters === void 0 ? void 0 : filters.push(sort);
  }
  return filters;
};
var _default = addSortFilters;
exports["default"] = _default;

/***/ }),

/***/ 36880:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Op = exports.ZP = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _head = _interopRequireDefault(__webpack_require__(49600));
var _router = __webpack_require__(53746);
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _LanguageProvider = __webpack_require__(8989);
var _useSalesmanago = _interopRequireDefault(__webpack_require__(54569));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var META_TYPE = {
  searchResults: "product-search",
  productPage: "product-page",
  categoryPage: "category-page, product-list"
};
exports.Op = META_TYPE;
Object.freeze(META_TYPE);
var defaultProps = {
  siteName: "Dajar"
};
var MetaTags = function MetaTags(props) {
  var page = props.page,
    sku = props.sku,
    passedUrl = props.url,
    productRegularPrice = props.productRegularPrice,
    productSpecialPrice = props.productSpecialPrice,
    productAvailability = props.productAvailability,
    productBrand = props.productBrand,
    productCategory = props.productCategory,
    currentPageNumber = props.currentPageNumber,
    tags = props.tags,
    noFollow = props.noFollow,
    domains = props.domains,
    _props$siteName = props.siteName,
    siteName = _props$siteName === void 0 ? defaultProps.siteName : _props$siteName;
  var translations = {
    page: (0, _langLibrary["default"])("page")
  };
  var singleDomain = props.singleDomain,
    title = props.title,
    description = props.description,
    imageUrl = props.imageUrl;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  singleDomain = singleDomain ? "https://".concat(singleDomain) : null;
  var baseUrl = domains ? "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  })) : singleDomain;
  var router = (0, _router.useRouter)();
  var routePaths = router !== null && router !== void 0 && router.asPath ? router.asPath.split("?") : [];
  var defaultOgImage = "/static/images/dajar-og-image.jpg";
  if (currentPageNumber) {
    title += "| ".concat(translations.page, " ").concat(currentPageNumber);
  }
  var tagsPrefix = tags && tags.length > 3 ? tags.join(", ") + "... - " : tags && tags.length > 0 ? tags.join(", ") + " - " : "";
  title = tagsPrefix + title;
  description = tagsPrefix + description;
  var url = noFollow ? baseUrl + passedUrl : baseUrl + "".concat(routePaths[0]);
  imageUrl = imageUrl === undefined || page === META_TYPE.searchResults ? baseUrl + defaultOgImage : baseUrl + imageUrl;
  (0, _react.useEffect)(function () {
    handleSalesmanagoEvent("VISIT");
  }, [title]);
  if (title !== "undefined") {
    return __jsx(_head["default"], null, __jsx("title", null, title), __jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), __jsx("meta", {
      name: "robots",
      content: page === META_TYPE.searchResults || noFollow ? "noindex, nofollow" : "index, follow"
    }), __jsx("link", {
      rel: "canonical",
      href: url
    }), __jsx("meta", {
      name: "title",
      content: title
    }), __jsx("meta", {
      name: "description",
      content: description
    }), __jsx("meta", {
      property: "og:site_name",
      content: siteName
    }), __jsx("meta", {
      property: "og:locale",
      content: language === null || language === void 0 ? void 0 : language.language
    }), __jsx("meta", {
      property: "og:title",
      content: title
    }), __jsx("meta", {
      property: "og:description",
      content: description
    }), __jsx("meta", {
      property: "og:type",
      content: page === META_TYPE.productPage ? "product" : "website"
    }), __jsx("meta", {
      property: "og:url",
      content: url
    }), __jsx("meta", {
      property: "og:image",
      content: imageUrl
    }), __jsx("meta", {
      property: "og:image:alt",
      content: title
    }), page === META_TYPE.productPage && __jsx(_react["default"].Fragment, null, __jsx("meta", {
      property: "product:condition",
      content: "new"
    }), __jsx("meta", {
      property: "product:availability",
      content: productAvailability
    }), __jsx("meta", {
      property: "product:original_price:amount",
      content: productRegularPrice
    }), __jsx("meta", {
      property: "product:original_price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:price:amount",
      content: productSpecialPrice
    }), __jsx("meta", {
      property: "product:price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:retailer_item_id",
      content: sku
    }), __jsx("meta", {
      property: "product:brand",
      content: productBrand
    }), __jsx("meta", {
      property: "product:category",
      content: productCategory
    })), __jsx("meta", {
      property: "twitter:card",
      content: page === META_TYPE.productPage ? "product" : "summary_large_image"
    }), __jsx("meta", {
      property: "twitter:site",
      content: "@DAJARpl"
    }), __jsx("meta", {
      property: "twitter:url",
      content: url
    }), __jsx("meta", {
      property: "twitter:title",
      content: title
    }), __jsx("meta", {
      property: "twitter:description",
      content: description.slice(0, 100)
    }), __jsx("meta", {
      property: "twitter:image",
      content: imageUrl
    }));
  } else {
    return __jsx(_head["default"], null);
  }
};
var _default = MetaTags;
exports.ZP = _default;

/***/ }),

/***/ 60461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.filtersSetValue = exports.filtersReduce = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var filtersReduce = function filtersReduce(filtersValue, pickedFiltersKeysPrev) {
  var pickedFilters = Array.isArray(filtersValue) ? filtersValue.reduce(function (pickedFilters, filter) {
    if (filter.value) {
      if (Array.isArray(filter.value) && filter.value.length < 1) {
        return pickedFilters;
      }
      if (filter.id === "capacity" && filter.isConverted) {
        filter = _objectSpread(_objectSpread({}, filter), {}, {
          isConverted: false,
          value: {
            from: filter.value.from * 1000,
            to: filter.value.to * 1000
          }
        });
      }
      pickedFilters[filter.id] = filter.value;
    }
    return pickedFilters;
  }, {}) : filtersValue;
  var pickedFiltersKeys = Object.keys(pickedFilters);
  var newlyPickedFilterKey = pickedFiltersKeys.length === 1 ? pickedFiltersKeys[0] : pickedFiltersKeys.find(function (key) {
    return pickedFiltersKeysPrev.includes(key);
  });
  return {
    pickedFilters: pickedFilters,
    pickedFiltersKeys: pickedFiltersKeys,
    newlyPickedFilterKey: newlyPickedFilterKey
  };
};
exports.filtersReduce = filtersReduce;
var filtersSetValue = function filtersSetValue(filters, filtersValue, newlyPickedFilterKey, pickedFiltersKeys) {
  filters === null || filters === void 0 ? void 0 : filters.forEach(function (filter) {
    var _filtersValue$find3;
    if (newlyPickedFilterKey === filter.id) {
      var _filtersValue$find, _filtersValue$find2;
      return pickedFiltersKeys.length === 1 ? _objectSpread(_objectSpread({}, filters.find(function (pickedFilter) {
        return pickedFilter.id === filter.id;
      })), {}, {
        value: (_filtersValue$find = filtersValue.find(function (pickedFilter) {
          return pickedFilter.id === filter.id;
        })) === null || _filtersValue$find === void 0 ? void 0 : _filtersValue$find.value
      }) : _objectSpread(_objectSpread({}, filter), {}, {
        value: (_filtersValue$find2 = filtersValue.find(function (pickedFilter) {
          return pickedFilter.id === filter.id;
        })) === null || _filtersValue$find2 === void 0 ? void 0 : _filtersValue$find2.value
      });
    }
    return _objectSpread(_objectSpread({}, filter), {}, {
      value: (_filtersValue$find3 = filtersValue.find(function (pickedFilter) {
        return pickedFilter.id === filter.id;
      })) === null || _filtersValue$find3 === void 0 ? void 0 : _filtersValue$find3.value
    });
  });
  return filters;
};
exports.filtersSetValue = filtersSetValue;

/***/ }),

/***/ 42987:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var oneProductResultWithoutFilters = function oneProductResultWithoutFilters(_ref) {
  var totalCount = _ref.totalCount,
    products = _ref.products,
    filtersData = _ref.filtersData;
  var oneProduct = typeof window !== "undefined" && totalCount === 1 && (products === null || products === void 0 ? void 0 : products.length) === 1;
  if (!oneProduct) {
    return;
  }
  var withoutFilters = !filtersData.some(function (filter) {
    return filter.value;
  });
  return oneProduct && withoutFilters;
};
var _default = oneProductResultWithoutFilters;
exports.Z = _default;

/***/ }),

/***/ 35026:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.removeAdditionalParameterFromFiltersString = exports.removeAdditionalParameterFromFiltersPickedFromUrl = exports["default"] = void 0;
var parametersList = ["fbclid"];
var removeAdditionalParameterFromFiltersPickedFromUrl = function removeAdditionalParameterFromFiltersPickedFromUrl(pickedFilters) {
  pickedFilters.map(function (filter, index) {
    if (parametersList.find(function (parameter) {
      return parameter === filter;
    })) {
      pickedFilters.splice(index, 1);
    }
  });
  return pickedFilters;
};
exports.removeAdditionalParameterFromFiltersPickedFromUrl = removeAdditionalParameterFromFiltersPickedFromUrl;
var removeAdditionalParameterFromFiltersString = function removeAdditionalParameterFromFiltersString(filtersString) {
  // here I assume the additional parameter is always at the end of this string
  var chars = ["&", "?"];
  var correctedFiltersString = filtersString;
  parametersList.find(function (parameter) {
    var _char = chars.find(function (_char2) {
      return filtersString.indexOf("".concat(_char2).concat(parameter)) > -1;
    });
    if (_char) {
      var filtersStringArray = filtersString.split("".concat(_char).concat(parameter));
      correctedFiltersString = filtersStringArray[0];
    }
  });
  return correctedFiltersString;
};
exports.removeAdditionalParameterFromFiltersString = removeAdditionalParameterFromFiltersString;
var _default = removeAdditionalParameterFromFiltersPickedFromUrl; // function used to remove parameters added to url by Facebook
// later possibly also other analytic/marketing parameters
// removeAdditionalParameterFromFiltersPickedFromUrl
// needed because: these parameters cause filters to return empty result
// as the parameter is used as filter
// removeAdditionalParameterFromFiltersString
// needed because: last filter is removed when the parameter is added
exports["default"] = _default;

/***/ }),

/***/ 97358:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _cache = __webpack_require__(75800);
var _removeAdditionalParameterFromFiltersPickedFromUrl = _interopRequireWildcard(__webpack_require__(35026));
var _excluded = ["query"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var searchInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var context, searchFetcher, _context$query, query, filtersPickedFromUrl, page, urlContainsFilters, urlFilters, getFiltersFromUrl, filtersPickedFromUrlWithoutAdditionalParameters, pickedFilters, fullUrl, fetchedResult, _Object$keys, _context$cache, _context$cache$data$f, _context$cache$data, _context$cache$data$f2, foundKey, defaultFilters, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = _ref.context, searchFetcher = _ref.searchFetcher;
            _context$query = context.query, query = _context$query.query, filtersPickedFromUrl = (0, _objectWithoutProperties2["default"])(_context$query, _excluded);
            page = filtersPickedFromUrl !== null && filtersPickedFromUrl !== void 0 && filtersPickedFromUrl.p ? filtersPickedFromUrl.p : 1;
            if (filtersPickedFromUrl !== null && filtersPickedFromUrl !== void 0 && filtersPickedFromUrl.p) {
              delete filtersPickedFromUrl.p;
            }
            urlContainsFilters = context.asPath.includes("?");
            urlFilters = filtersPickedFromUrl;
            getFiltersFromUrl = function getFiltersFromUrl() {
              var dataPairArray = [];
              var url = context.asPath.split("?");
              var filters = url[1].split("&");
              filters.forEach(function (filter) {
                var dataPair = filter.split("=");
                if (dataPair[0] === "p") return;
                var dataArray = [];
                dataArray.push(dataPair[0]);
                dataArray.push(dataPair[1]);
                dataPairArray.push(dataArray);
              });
              return Object.fromEntries(dataPairArray);
            };
            if (Object.keys(urlFilters).length === 0 && urlContainsFilters) {
              urlFilters = getFiltersFromUrl();
            }
            filtersPickedFromUrlWithoutAdditionalParameters = (0, _removeAdditionalParameterFromFiltersPickedFromUrl["default"])(Object.keys(urlFilters));
            pickedFilters = filtersPickedFromUrlWithoutAdditionalParameters.reduce(function (acc, current) {
              if (current === "dir" || current === "p") {
                return acc;
              }
              if (current === "order") {
                var orderFilterWithParameterRemoved = (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(urlFilters[current]);
                acc["sort"] = {
                  id: "".concat(orderFilterWithParameterRemoved, "-").concat(urlFilters["dir"]),
                  value: "".concat(orderFilterWithParameterRemoved, "-").concat(urlFilters["dir"])
                };
                return acc;
              }
              var rangeFilters = ["diameter", "height", "width", "length", "final_price", "capacity"];
              if (rangeFilters.includes(current)) {
                var range = urlFilters[current].split("-");
                var toRangeWithParameterRemoved = (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(range[1]);
                acc[current] = {
                  from: current === "capacity" ? Number(range[0] * 1000) : Number(range[0]),
                  to: current === "capacity" ? Number(toRangeWithParameterRemoved * 1000) : Number(range[1])
                };
                return acc;
              }
              acc[current] = urlFilters[current].split(",").map(function (id) {
                return {
                  id: (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(id)
                };
              });
              return acc;
            }, {});
            fullUrl = decodeURIComponent(context.asPath);
            fetchedResult = (0, _cache.getResultFromCache)(fullUrl, context.cache);
            if (fetchedResult) {
              _context.next = 22;
              break;
            }
            foundKey = (_Object$keys = Object.keys((_context$cache = context.cache) === null || _context$cache === void 0 ? void 0 : _context$cache.data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (key) {
              return key.includes("catalogsearch/result");
            });
            defaultFilters = (_context$cache$data$f = (_context$cache$data = context.cache.data) === null || _context$cache$data === void 0 ? void 0 : (_context$cache$data$f2 = _context$cache$data[foundKey]) === null || _context$cache$data$f2 === void 0 ? void 0 : _context$cache$data$f2.defaultFilters) !== null && _context$cache$data$f !== void 0 ? _context$cache$data$f : null;
            _context.next = 17;
            return searchFetcher({
              phrase: encodeURIComponent(context.query.query),
              language: context.language,
              pickedFilters: pickedFilters,
              currentPage: page,
              pageSize: __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange,
              initialFilters: defaultFilters
            });
          case 17:
            result = _context.sent;
            (0, _cache.setUrlInCache)((0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(fullUrl), result, context.cache);
            return _context.abrupt("return", {
              initialProductsAndFilters: result,
              initialQuery: context.query.query,
              initialPage: page,
              pickedFilters: pickedFilters,
              cache: context.cache
            });
          case 22:
            return _context.abrupt("return", {
              initialProductsAndFilters: fetchedResult,
              initialQuery: context.query.query,
              pickedFilters: pickedFilters,
              cache: context.cache
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function searchInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = searchInitialProps;
exports.Z = _default;

/***/ }),

/***/ 88778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _RouteContext = __webpack_require__(73157);
var _Container = _interopRequireDefault(__webpack_require__(58709));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  titleAs: "h3",
  centeredTitle: true,
  headerFont: "xxl",
  headerIndent: 0,
  descriptionFont: "base_sans_bold",
  withBorder: true,
  titleColor: "main",
  descriptionColor: "main",
  bottomBorderColor: "main",
  noSpaceAfterHeader: false,
  withContainer: false
};
var SectionWithConfigurableHeader = function SectionWithConfigurableHeader(props) {
  var title = props.title,
    link = props.link,
    children = props.children,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    _props$centeredTitle = props.centeredTitle,
    centeredTitle = _props$centeredTitle === void 0 ? defaultProps.centeredTitle : _props$centeredTitle,
    description = props.description,
    _props$headerFont = props.headerFont,
    headerFont = _props$headerFont === void 0 ? defaultProps.headerFont : _props$headerFont,
    _props$headerIndent = props.headerIndent,
    headerIndent = _props$headerIndent === void 0 ? defaultProps.headerIndent : _props$headerIndent,
    _props$noSpaceAfterHe = props.noSpaceAfterHeader,
    noSpaceAfterHeader = _props$noSpaceAfterHe === void 0 ? defaultProps.noSpaceAfterHeader : _props$noSpaceAfterHe,
    _props$descriptionFon = props.descriptionFont,
    descriptionFont = _props$descriptionFon === void 0 ? defaultProps.descriptionFont : _props$descriptionFon,
    _props$withBorder = props.withBorder,
    withBorder = _props$withBorder === void 0 ? defaultProps.withBorder : _props$withBorder,
    _props$titleColor = props.titleColor,
    titleColor = _props$titleColor === void 0 ? defaultProps.titleColor : _props$titleColor,
    _props$descriptionCol = props.descriptionColor,
    descriptionColor = _props$descriptionCol === void 0 ? defaultProps.descriptionColor : _props$descriptionCol,
    _props$bottomBorderCo = props.bottomBorderColor,
    bottomBorderColor = _props$bottomBorderCo === void 0 ? defaultProps.bottomBorderColor : _props$bottomBorderCo,
    additionalBlock = props.additionalBlock,
    mobileLinkButton = props.mobileLinkButton,
    _props$withContainer = props.withContainer,
    withContainer = _props$withContainer === void 0 ? defaultProps.withContainer : _props$withContainer;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var border = {
    borderBottomWidth: description ? "2px" : 0,
    borderBottomStyle: "solid",
    borderBottomColor: bottomBorderColor
  };
  var headerContent = __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: _objectSpread({
      textAlign: centeredTitle ? "center" : ["center", null, "left"],
      display: additionalBlock ? "flex" : description ? "inline-block" : "block",
      justifyContent: "space-between",
      font: headerFont,
      mb: description || noSpaceAfterHeader ? 0 : link ? ["200px"] : ["s8", null, null, "s10", null, null],
      pr: description ? [0, null, "s13"] : 0,
      pb: description ? "s5" : 0,
      pl: headerIndent,
      color: titleColor
    }, withBorder && border),
    as: titleAs
  }, additionalBlock ? __jsx(_Box["default"], null, title) : title, additionalBlock && __jsx(_Box["default"], null, additionalBlock)), description && __jsx(_Box["default"], {
    sx: {
      font: descriptionFont,
      color: descriptionColor,
      mb: "s10",
      mt: "s5"
    }
  }, description), link && __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: "s_sans",
      mt: noSpaceAfterHeader ? "s5" : 0,
      mb: ["s8", null, null, "s10", null, null],
      color: "main",
      textDecoration: "underline",
      cursor: "pointer"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: {
      url: (link === null || link === void 0 ? void 0 : link.url.indexOf("/")) === 0 ? link.url.replace("/", "") : link.url
    }
  }, __jsx(_LinkRaw["default"], {
    title: link.name
  }, link.name))));
  return withContainer ? __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Container["default"], null, headerContent), children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "") : __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, headerContent, " ", children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "");
};
var _default = SectionWithConfigurableHeader;
exports.Z = _default;

/***/ }),

/***/ 39465:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogsearch/result/[...query]",
      function () {
        return __webpack_require__(80532);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MetaTags; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../components-new/dist/MetaTags/index.js
var MetaTags = __webpack_require__(36880);
;// CONCATENATED MODULE: ./conf/lang.domains.json
var lang_domains_namespaceObject = JSON.parse('{"dajar.cz":"cz","dajar.de":"de","dajar.es":"es","dajar.fr":"fr","dajar.pl":"pl","dajar.it":"it","dajar.co.uk":"gb","dajar.ro":"ro","dajar.se":"se","dajar.sk":"sk"}');
;// CONCATENATED MODULE: ./src/components/MetaTags/index.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MetaTags_MetaTags = function(props) {
    var propsExt = _objectSpread({}, props, {
        domains: lang_domains_namespaceObject
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.ZP, _objectSpread({}, propsExt)));
};
/* harmony default export */ var components_MetaTags = (MetaTags_MetaTags);


/***/ }),

/***/ 80532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94986);
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34885);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53746);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51493);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42223);
/* harmony import */ var _c_category__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84749);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _commerce_ui_core2_useWindowSize__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47272);
/* harmony import */ var _commerce_ui_core2_useWindowSize__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_useWindowSize__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_Pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62067);
/* harmony import */ var _components_FiltersBarDesktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17930);
/* harmony import */ var _components_FiltersBarMobile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34801);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39125);
/* harmony import */ var _deosite_api_hooks_REST_useSearchNew__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(39822);
/* harmony import */ var _deosite_api_hooks_common_useAnalytics4AndCommerceTags__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79892);
/* harmony import */ var _deosite_api_hooks_common_useNormalizeAndMapFilters__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68885);
/* harmony import */ var _deosite_helpers_oneProductResultWithoutFilters__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42987);
/* harmony import */ var _deosite_helpers_searchInitialProps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97358);


















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SearchPage(props) {
    var ref5;
    var initialProductsAndFilters = props.initialProductsAndFilters, initialQuery = props.initialQuery, pickedFilters = props.pickedFilters, cache = props.cache;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var query = initialQuery || router.query.query;
    var translations = {
        searchResults: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__["default"])("Search results | Dajar"),
        searchResultsWithQuery: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__["default"])("search results", {
            phrase: query
        })
    };
    var ref1;
    var initialPage = (ref1 = (ref5 = router.asPath.match(/p=([0-9]*)/)) === null || ref5 === void 0 ? void 0 : ref5[1]) !== null && ref1 !== void 0 ? ref1 : 1;
    var size = _commerce_ui_core2_useWindowSize__WEBPACK_IMPORTED_MODULE_8___default()();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), isMobile = ref2[0], setMobile = ref2[1];
    var firstUpdate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)({
        query: "",
        isFirst: true
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isMobileSize = size.width <= parseInt((0,_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().breakpoints.md);
        if (isMobile !== isMobileSize) {
            setMobile(isMobileSize);
        }
    }, [
        size.width
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (firstUpdate.current.isFirst) {
            firstUpdate.current.isFirst = false;
        }
    });
    var ref3 = (0,_deosite_api_hooks_REST_useSearchNew__WEBPACK_IMPORTED_MODULE_13__/* .useSearchNew */ .wd)({
        phrase: query,
        currentPage: initialPage,
        pageSize: __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange,
        initialData: initialProductsAndFilters,
        pickedFilters: pickedFilters,
        cacheSSR: cache,
        router: router
    }), products = ref3.results, filters1 = ref3.filters, totalCount = ref3.totalCount, changeSearchPagination = ref3.changeSearchPagination;
    var ref4 = (0,_deosite_api_hooks_common_useNormalizeAndMapFilters__WEBPACK_IMPORTED_MODULE_15__["default"])({
        data: filters1
    }), filtersData = ref4.filters;
    var searchPhrase = (0,_deosite_api_hooks_common_useAnalytics4AndCommerceTags__WEBPACK_IMPORTED_MODULE_14__["default"])().searchPhrase;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        searchPhrase(query[0]);
    }, [
        query
    ]);
    if ((0,_deosite_helpers_oneProductResultWithoutFilters__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        totalCount: totalCount,
        products: products,
        filtersData: filtersData
    })) {
        router === null || router === void 0 ? void 0 : router.push("/[...categoryOrProductPage]", "/".concat(products[0].url), {
            shallow: true
        });
    }
    var changeUrlAfterFiltering = function() {
        var _ref = _asyncToGenerator(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(filters) {
            var url;
            return _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return changeSearchPagination(filters, 1, __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange, query);
                    case 2:
                        url = _ctx.sent;
                        router.push("/catalogsearch/result/[...query]", url, {
                            shallow: true
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeUrlAfterFiltering(filters) {
            return _ref.apply(this, arguments);
        };
    }();
    var filtersBar = pickedFilters && isMobile !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_FiltersBarMobile__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            data: filtersData,
            onChange: changeUrlAfterFiltering
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_FiltersBarDesktop__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            data: filtersData,
            onChange: changeUrlAfterFiltering
        })
    });
    var onPageChange = function() {
        var _ref = _asyncToGenerator(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pageToSet) {
            var ref, asPath, urlPath, pathAlreadyContainsQuestionMark, pageStringToSet;
            return _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        asPath = router.asPath;
                        urlPath = asPath.indexOf("?p=") >= 0 ? asPath.split("?p=") : asPath.split("&p=");
                        _ctx.next = 5;
                        return changeSearchPagination(filtersData, pageToSet, __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange, query);
                    case 5:
                        pathAlreadyContainsQuestionMark = ((ref = urlPath[0]) === null || ref === void 0 ? void 0 : ref.indexOf("?")) >= 0;
                        pageStringToSet = pathAlreadyContainsQuestionMark ? "&p=".concat(pageToSet) : "?p=".concat(pageToSet);
                        router.push("/catalogsearch/result/[...query]", "".concat(urlPath[0]).concat(pageStringToSet), {
                            shallow: true
                        }).then(function() {
                            return window.scrollTo(0, 0);
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPageChange(pageToSet) {
            return _ref.apply(this, arguments);
        };
    }();
    var pagesAmount = Math.ceil(totalCount / __webpack_require__.g.__appConfig__.categoryPageSizeLargerRange);
    var pagination = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Pagination__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        pagesAmount: Number.isNaN(pagesAmount) ? 1 : pagesAmount,
        currentPage: initialPage,
        onChange: onPageChange
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: translations.searchResults,
                description: translations.searchResults,
                noFollow: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_7___default()), {
                sx: {
                    mt: "s9",
                    mb: "s9"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_c_category__WEBPACK_IMPORTED_MODULE_6__["default"], {
                categoryProducts: products !== null && products !== void 0 ? products : [],
                totalCount: totalCount,
                currentCategory: {
                    name: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_4__["default"])("search results", {
                        phrase: query
                    })
                },
                filtersBar: filtersBar,
                pagination: pagination,
                footerContent: props.footerContent,
                isSearchPage: true
            })
        ]
    }));
}
SearchPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        return _usr_src_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_deosite_helpers_searchInitialProps__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                        context: context,
                        searchFetcher: _deosite_api_hooks_REST_useSearchNew__WEBPACK_IMPORTED_MODULE_13__/* .fetcher */ ._i
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = (SearchPage);


/***/ }),

/***/ 44553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88778);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SectionWithConfigurableHeader = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionWithConfigurableHeader);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [902,6002,2067,9281,2520,6346,9774,2888,179], function() { return __webpack_exec__(39465); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);